import type { MedicAuthData } from "./base";
import BaseAuthenticator from "./base";

interface OpenIdAuthArgs {
  authorizationCode: string;
  issuer: string;
  validationNumber?: string | number;
}

interface OpenIdAuthData extends MedicAuthData {
  id_token: string;
  open_id_refresh_token?: string;
  open_id_issuer: string;
}

export default class OpenIdConnectAuthenticator extends BaseAuthenticator<OpenIdAuthData> {
  loginEndpoint = "/api/v1/medic_login";
  userClassName: "Medic" | "Patient" = "Medic";

  async authenticate({
    authorizationCode,
    issuer,
    validationNumber
  }: OpenIdAuthArgs): Promise<OpenIdAuthData | undefined> {
    let data;
    try {
      const response = await this.sendLoginRequest({
        authorization_code: authorizationCode,
        issuer,
        ...(validationNumber === undefined
          ? {}
          : { validation_number: validationNumber })
      });

      data = {
        as: "medic",
        id: response.id,
        uuid: response.uuid,
        role: response.role,
        is_super_user: response.is_super_user,
        first_health_centre_uuid: response.first_health_centre_uuid,
        access_token: response.access_token,
        id_token: response.id_token,
        open_id_refresh_token: response.open_id_refresh_token,
        open_id_issuer: issuer
      };
    } catch (response) {
      throw {
        reason: response
      };
    }

    return this.onAuthenticationFinished(data);
  }
}
